<template>
  <div class="health-page">
    <PopupContainer
      initial-open
      name="health"
      class="health-popup"
      :enter-animation="false"
    >
      <template slot="title">
        <Title
          title="alkohol"
          subtitle="a zdrowie"
          reverse-colors
          class="contact-title"
        />
      </template>
      <template slot="first">
        <p>
          Spożycie alkoholu to&nbsp;indywidualny wybór. Napoje alkoholowe mogą
          różnie wpływać na&nbsp;poszczególne osoby. Niektóre badania
          sugerują,&nbsp;że istnieje związek między piciem alkoholu
          a&nbsp;zwiększonym ryzykiem rozwoju pewnych problemów zdrowotnych.
          Regularne, intensywne picie prowadzi prostą drogą do&nbsp;choroby.
          Wiąże&nbsp;się ono z&nbsp;wieloma poważnymi schorzeniami, takimi jak
          choroby wątroby, układu krążenia, uzależnienie, a&nbsp;także
          zwiększone ryzyko zachorowania na&nbsp;różne nowotwory. Szczególnie
          niebezpieczne jest spożywanie dużych ilości alkoholu w&nbsp;krótkim
          czasie. To&nbsp;realne zagrożenie mogące prowadzić do&nbsp;poważnych
          konsekwencji dla zdrowia.
        </p>
      </template>

      <template slot="second">
        <p>
          Dla niektórych osób nawet umiarkowane picie alkoholu może zwiększać
          ryzyko zachorowania na&nbsp;niektóre nowotwory, w&nbsp;tym raka
          piersi. Nie tylko tempo picia ma znaczenie. Ilość, częstotliwość,
          wiek, płeć, geny i&nbsp;styl życia – wszystko to&nbsp;razem wpływa
          na&nbsp;to, jak&nbsp;alkohol oddziałuje na&nbsp;nasze ciało. Dlatego
          właśnie warto porozmawiać z&nbsp;lekarzem lub specjalistą, aby
          się&nbsp;dowiedzieć, czy nawet umiarkowane spożycie alkoholu nie wiąże
          się z&nbsp;ryzykiem dla Twojego zdrowia.
        </p>
        <p class="learn-more">
          PRZECZYTAJ WIĘCEJ NA:
        </p>
        <div class="link-wrapper">
          <a
            class="link"
            target="_blank"
            href="https://www.moderationmatters.com"
            rel="noopener noreferrer"
            >www.moderationmatters.com
          </a>
        </div>
      </template>
    </PopupContainer>
  </div>
</template>

<script>
import PopupContainer from '@/components/popups/PopupContainer'
import Title from '@/components/common/Title'

export default {
  components: { PopupContainer, Title },
  watch: {
    '$store.state.activePopup'(value) {
      if (value === '') {
        this.$router.push('/')
      }
    }
  },
  mounted() {
    this.$store.commit('togglePopup', 'health')
  }
}
</script>

<style lang="scss" scoped>
.health-page {
  position: relative;
  min-height: $vh;

  font-family: $light-font;
  font-size: 10px;
  line-height: 1.2em;
  letter-spacing: 0.03em;

  @include media-up(md) {
    font-size: 18px;
    line-height: 1.67em;
    letter-spacing: 0.05em;
  }
}

/deep/ .logo {
  @include media-up(lg) {
    position: absolute;
  }
}

/deep/ .popup-wrapper {
  z-index: z(health-popup);

  @media (max-height: 900px) {
    display: block;
  }

  @include media-down(md) {
    padding: 15px 20px 20px 15px;
  }
}

/deep/ .content--health {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto 1fr;

  @include media-up(xxl) {
    padding-right: 6vw;
  }
}

.contact-title {
  grid-row: 1;
  grid-column: 1;

  @include media-down(lg) {
    grid-row: 1;
    grid-column: 1/ 3;
    margin-bottom: 28px;
  }
}

/deep/ .fraction--first {
  grid-row: 2;
  grid-column: 1;

  @include media-down(lg) {
    grid-row: 2;
    grid-column: 1 / 3;
  }
  @include media-up(xxl) {
    margin-right: 8.2vw;
  }
}

/deep/ .fraction--second {
  grid-row: 2;
  grid-column: 2;

  @include media-down(lg) {
    grid-row: 3;
    grid-column: 1 / 3;
    padding-top: 27px;
  }
}

.learn-more {
  margin: 32px 0 11px;
  font-family: $regular-font;
  font-size: 18px;
  line-height: 30px;
}

.link-wrapper {
  @include media-down(lg) {
    margin-bottom: 10px;
  }
}

.link {
  display: inline;
  font-family: $regular-font;
  color: $text-color;
  text-decoration: none;
  border-bottom: 1px solid $text-color;
  line-height: 2em;
  text-transform: uppercase;

  @include media-up(md) {
    border-width: 2px;
  }
}
</style>
